export class DNC {
  static BLOCK_EXPLORER_URL = 'https://block-explorer.constellationnetwork.io';
  static LOAD_BALANCER_URL = 'http://lb.constellationnetwork.io:9000';
  static L0_URL = 'http://13.52.246.74:9000';
  static L1_URL = 'http://13.52.246.74:9010';
}

